import React from "react";
import TopIssuesDonutChart from "./TopIssuesDonutChart";
import AllIssueCategoryList from "./AllIssueCategoryList";


export const Categorychart = ({
         datas,
  PriorityValues,
  SttausValues,
  Client,
  date,
  range
}) => {


  return (
    <div style={{ display: "flex", gap:"21px", flexDirection:"column" }}>
   
    <div style={{ display: "flex", gap:"21px" }}>
        <div style={{ flex: 1 }}>
        <TopIssuesDonutChart 
      datas={datas}
      PriorityValues={PriorityValues}
      SttausValues={SttausValues}
      Client={Client}
      range={range}
      date={date}
        
        />
      </div>

      <div style={{ flex: 1 }}>
        <AllIssueCategoryList 
      datas={datas}
      PriorityValues={PriorityValues}
      SttausValues={SttausValues}
      Client={Client}
      range={range}
      date={date}
        />
      </div>
</div>
    </div>
  );
};
